import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appTableCellFooter]',
  standalone: true,
})
export class TableCellFooterDirective {
  public readonly templateRef = inject(TemplateRef);

  public appTableCellFooterKey = input.required<string>();
}
